import { mq } from './breakpoints';

// How many options *Add tag* lists, by window, and the windows that decide it: one rule for the lead's *Add tag*
// and the account's and contact's (BUG-255), which `useAddTagOptionsMax` applies. A plain module, so the browser
// tests (`e2e/browser/leads/lead-detail-support.ts`, `e2e/browser/accounts/add-tag-window.spec.ts`) read the same
// numbers without loading the component, React or its CSS Module.

/**
 * The most options *Add tag* lists at once, *Create tag* included (BUG-123). A list that scrolls holds
 * nothing focusable in a combobox, which axe reports as `scrollable-region-focusable`; a bounded list is
 * passed as the Combobox's `shortList`, which drops its height limit so it never scrolls.
 */
export const ADD_TAG_OPTIONS_MAX = 10;

/**
 * The most options in a window narrower or shorter than `ADD_TAG_ROOMY_WINDOW`, where ten rows and the line
 * under them can be taller than the room the window leaves above or below the field, so the list would run
 * out of the window. Seven fit at 320 × 640 with the field mid-window (the size matrix's
 * `leads-lead-tag-picker-many`), and in any window from `ADD_TAG_SHORT_HEIGHT` tall; a shorter one lists
 * `ADD_TAG_OPTIONS_MAX_SHORT` (BUG-206).
 */
export const ADD_TAG_OPTIONS_MAX_SMALL = 7;

/**
 * The shortest window that lists `ADD_TAG_OPTIONS_MAX` *Add tag* options (BUG-203), in CSS px. Ten rows and
 * the line under them take about 390px on one side of the 44px field. The list opens on the side with more
 * room, which is least when the field sits mid-window, so the window needs twice that plus the field and the
 * library's 12px edge padding. Below it, as at 1280 × 720, ten rows ran off the window.
 */
export const ADD_TAG_ROOMY_HEIGHT = 860;

/** The window that lists `ADD_TAG_OPTIONS_MAX`: at least `bp/tablet` wide and `ADD_TAG_ROOMY_HEIGHT` tall. */
export const ADD_TAG_ROOMY_WINDOW = `${mq.tablet} and (min-height: ${ADD_TAG_ROOMY_HEIGHT}px)`;

/**
 * The shortest window that lists `ADD_TAG_OPTIONS_MAX_SMALL` (seven) options (BUG-206), in CSS px. Measured in
 * Chromium: an option row is 30.1px, and the popover is the rows plus 40.5px (the line under them and the
 * padding), opening 6.6px from the 44px field. With the field mid-window and the library's 12px edge padding,
 * seven fit from about 584px tall; this keeps a little room. Below it, as in a short browser window or a
 * 1280 × 720 window zoomed to 200% (640 × 360), the list lists `ADD_TAG_OPTIONS_MAX_SHORT`.
 */
export const ADD_TAG_SHORT_HEIGHT = 600;

/**
 * The most options in a window shorter than `ADD_TAG_SHORT_HEIGHT`. Three fit, with the field mid-window, from
 * about 345px tall, which covers a 1280 × 720 window zoomed to 200%; four do not fit at 360px.
 */
export const ADD_TAG_OPTIONS_MAX_SHORT = 3;

/**
 * The window tall enough to list `ADD_TAG_OPTIONS_MAX_SMALL` when it is not `ADD_TAG_ROOMY_WINDOW`: at least
 * `ADD_TAG_SHORT_HEIGHT` tall, at any width. A window that is neither lists `ADD_TAG_OPTIONS_MAX_SHORT`.
 */
export const ADD_TAG_SMALL_WINDOW = `(min-height: ${ADD_TAG_SHORT_HEIGHT}px)`;
